<script setup>
import { ref } from 'vue';

const props = defineProps({
  title: { type: String, required: true },
  icon: { type: String, default: 'i-lucide-folder' },
  count: { type: Number, default: null },
  defaultOpen: { type: Boolean, default: true },
});

const isOpen = ref(props.defaultOpen);
const toggle = () => {
  isOpen.value = !isOpen.value;
};
</script>

<template>
  <section
    class="flex flex-col overflow-hidden border rounded-xl border-n-weak bg-n-solid-2"
  >
    <button
      type="button"
      class="flex items-center justify-between gap-2 px-4 h-11 text-sm font-medium transition-colors text-n-slate-12 hover:bg-n-alpha-1"
      :aria-expanded="isOpen"
      @click="toggle"
    >
      <span class="flex items-center gap-1.5 min-w-0">
        <span :class="icon" class="size-4 shrink-0 text-n-slate-10" />
        <span class="truncate">{{ title }}</span>
        <span
          v-if="count !== null"
          class="px-1.5 py-0.5 text-xs rounded-md tabular-nums bg-n-alpha-2 text-n-slate-11"
        >
          {{ count }}
        </span>
      </span>
      <span
        class="size-4 shrink-0 text-n-slate-10 transition-transform"
        :class="isOpen ? 'i-lucide-chevron-up' : 'i-lucide-chevron-down'"
      />
    </button>
    <div v-if="isOpen" class="px-4 pb-4 border-t border-n-weak pt-3">
      <slot />
    </div>
  </section>
</template>
